export default __webpack_public_path__ + "assets/72b7fd29911d52d71fb276530433393b.svg";